import { render } from "./ManageClases.vue?vue&type=template&id=3bb3c3ee&scoped=true"
import script from "./ManageClases.vue?vue&type=script&lang=js"
export * from "./ManageClases.vue?vue&type=script&lang=js"

import "./ManageClases.vue?vue&type=style&index=0&id=3bb3c3ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb3c3ee"]])

export default __exports__